<template><profit-loss-document-page direction="loss" /></template>
<script>
import ProfitLossDocumentPage from '../profitloss/ProfitLossDocumentPage'
export default { name: 'ErpStockLoss', components: { ProfitLossDocumentPage } }
</script>
